import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as actions from '../../store/actions/index';
import Select from 'react-select'
import useCustomTranslation from '../../hooks/useCustomTranslation';

const ProjectSolutionHoleSubform = (props) => {

  const { t } = useTranslation();
  const ct = useCustomTranslation();
  const { watch, getValues, handleSubmit, errors, register, setValue, control } = useForm();
  const { hole_form } = watch();

  const holeFormOptions = () => actions.availableHoleForms.map( x => { return { value: x.toLowerCase(), label:  ct('modal.product_solution_meta_data.form.hole_form_' + x + '.label') }} )

  const initialValues = {
    hole_form: ((props.calculator && props.calculator.hole_form) || holeFormOptions()[0].value),
    hole_diameter: ((props.calculator && props.calculator.hole_diameter) || 0),
    hole_width: ((props.calculator && props.calculator.hole_width) || 0),
    hole_height: ((props.calculator && props.calculator.hole_height) || 0)
  }


  const onCancel = () => {
    setValue('hole_height', initialValues['hole_height']);
    setValue('hole_width', initialValues['hole_width']);
    setValue('hole_diameter', initialValues['hole_diameter']);
    setValue('hole_form', initialValues['hole_form']);
    props.cancelCalculatorForm();
  }

  const onSubmit = data => {
    if (props.calculatorToParent !== undefined) {
      props.calculatorToParent()(data.hole_form, data.hole_width, data.hole_height, data.hole_diameter);
      props.cancelCalculatorForm();
    }
  } ;

    const handleHoleFormChange = selectedOption => {
      setValue("hole_form", selectedOption.value);
    };

    useEffect(() => {
      setValue("hole_form", initialValues['hole_form']);
    }, []);

    const handleOnChangeNumberFields = (e) => {
       const new_string_value = e.target.value.split(/\D/).join('')
       let new_number_string = parseFloat(new_string_value).toString();
       if (new_number_string === "NaN") {
         new_number_string = 0;
       }
       setValue(e.target.name, new_number_string)
    }

    const isItValid = (errors, fieldName) => {
      return (errors[fieldName] !== undefined)? "is-invalid" : ""
    }


    const selectHoleForm = () => (<div style={{display: "inline-block", width: "200px"}}>
         <Controller
            control={control}
            name="hole_form"
            defaultValue={ holeFormOptions().filter(function(element, index, arr){ return element.value === initialValues['hole_form']})[0] }
            render= {({onChange, value, ref}) => (
            <Select

            ref={register('hole_form')}
              options={holeFormOptions()}
              onChange={handleHoleFormChange}
              value={ holeFormOptions().filter(function(element, index, arr){ return element.value === hole_form})[0] }
              inputRef={ref}
            />
          )}
          />
        </div>)

  const inputHoleWidth = () => (
    <input
      style={{display: "inline-block", width: "70px"}}
      className={"form-control " + isItValid(errors, 'hole_width') }
      onChange={handleOnChangeNumberFields}
      name="hole_width"
      value={getValues('hole_width')}
      defaultValue={initialValues.hole_width}
      ref={ register({
        min: 10
      })}
    />
  )

  const inputHoleHeight = () => (
    <input
      style={{display: "inline-block", width: "70px"}}
      className={"form-control " + isItValid(errors, 'hole_height') }
      onChange={handleOnChangeNumberFields}
      name="hole_height"
      value={getValues('hole_height')}
      defaultValue={initialValues.hole_height}
      ref={ register({
        min: 10
      })}
    />
  )

  const inputHoleDiameter = () => (
    <input
      style={{display: "inline-block", width: "70px"}}
      className={"form-control " + isItValid(errors, 'hole_diameter') }
      onChange={handleOnChangeNumberFields}
      name="hole_diameter"
      value={getValues('hole_diameter')}
      defaultValue={initialValues.hole_diameter}
      ref={ register({
        min: 10
      })}
    />
  )

   const formElements = () => (
         <div style={{width: "400px"}}>
           <label style={{display: "inline-block"}}>{ t('product_solution.calculation_result.form_des_durchbruchs') }:</label> {selectHoleForm()}<br/>

           { (hole_form === "square") && (
             <div style={ {paddingTop: "10px"} }>
               <label style={ {display: "inline-block"} }>{ t('product_solution.calculation_result.form.breite') }</label> { inputHoleWidth() }
               <label style={ {display: "inline-block", paddingLeft: "10px"} }>{ t('product_solution.calculation_result.form.hoehe') }</label> { inputHoleHeight() }
             </div>
           )}

           { (hole_form === "circle") && (
             <div style={ {paddingTop: "10px"} }>
               <label style={ {display: "inline-block"} }>{ t('product_solution.calculation_result.form.durchmesser') }</label> { inputHoleDiameter() }
             </div>
           )}

           { ((hole_form === "circle") || (hole_form === "square")) && (
             <div style={ {paddingTop: "10px"} }>
               { (props.showCancelButton === true) ?
                 <button className="btn btn-primary" style={ {marginRight: "10px"} } onClick={()=> onCancel()}>{ t('product_solution.calculation_result.form.button_abbrechen') }</button> : null
               }
               <button type="submit" className="btn btn-primary">{ t('product_solution.calculation_result.form.button_save') }</button>
             </div>

           )}


           { ((hole_form !== "circle") && (hole_form !== "square") && (initialValues['hole_form'] !== 'none')) && (
             <div style={ {paddingTop: "10px"} }>
               { (props.showCancelButton === true) ?
                 <button className="btn btn-primary" style={ {marginRight: "10px"} } onClick={()=> onCancel()}>{ t('product_solution.calculation_result.form.button_abbrechen') }</button> : null
               }
               <button type="submit" className="btn btn-primary">{ t('product_solution.calculation_result.form.button_save') }</button>
             </div>

           )}


         </div>
       )


    return (
      <div className="container">
        <div className="row">
          <div className="col-sm">
            <form onSubmit={handleSubmit(onSubmit)} className="form">
              { formElements() }
            </form>
          </div>
          <div className="col-sm">
          </div>
        </div>
      </div>
    )
}

export default ProjectSolutionHoleSubform



// WEBPACK FOOTER //
// ./src/components/Modals/ProjectSolutionHoleSubform.js